var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _polygon, _g, _g2, _line, _rect, _rect2, _rect3, _path8, _circle, _circle2, _circle3, _rect4, _path9, _path10, _path11, _path12, _rect5, _path13, _path14, _path15, _path16, _path17, _rect6, _rect7, _rect8, _rect9, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWelcomeOnboarding(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 883.5 648",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".d{fill:#cedcf0;}.d,.e,.f,.g,.h,.i,.j,.k,.l,.m,.n,.o,.p,.q,.r,.s{stroke-width:0px;}.e{fill:#6586b4;}.f,.i{fill:#000;}.g{fill:#e0e0e0;}.h{fill:#633029;}.t{stroke:#263238;}.t,.u,.v,.w{stroke-linecap:round;stroke-linejoin:round;}.t,.u,.x{fill:none;}.i{opacity:.2;}.i,.o{isolation:isolate;}.j{fill:#ffbe9d;}.k{fill:#eea886;}.l,.y{fill:#0951b4;}.m{fill:#263238;}.y{stroke:#0951b4;}.y,.x{stroke-miterlimit:10;}.n{fill:#a6bcdb;}.o{opacity:.8;}.o,.v,.r{fill:#fff;}.p{fill:#407bff;}.u{stroke:#407bff;}.q{fill:#8e4f3a;}.v,.w{stroke:#666;}.x{stroke:#e0e0e0;}.w{fill:#dedede;}.s{fill:#16202e;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M106.34,346.17S86.04,106.2,303.57,54.35c217.53-51.84,278.01,121.14,401.89,148.24,123.88,27.09,217.2,176.11,100.31,330.19-116.89,154.08-682.47,188.16-699.43-186.61Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "m",
    d: "M142.56,562.76c10.27-7.22,22.29-57.56,23.01-87.55.37-15.36,4.91-21.76,8.91-27.4,3.83-5.4,7.14-10.06,5.21-20.76-3.68-20.45,6-29.28,6.1-29.37l-1.12-1.28c-.43.38-10.51,9.48-6.65,30.94,1.8,10-1.17,14.18-4.92,19.47-3.94,5.55-8.85,12.47-9.23,28.35-.77,32.18-13.06,79.71-22.29,86.2l.98,1.39Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "m",
    d: "M121.03,548.07c-.97-2.2-1.97-4.47-3.11-6.87-5.87-12.39-11.07-14.43-19.68-17.81-2.1-.83-4.49-1.76-7.11-2.94-12.34-5.54-9.95-13.71-7.84-20.92.29-1.01.59-2.01.84-3.01,1.09-4.24-1-6.37-4.15-9.59-2.35-2.39-5.26-5.37-7.51-10.07-2.46-5.15-1.21-7.91.28-9.32,3.13-2.97,10.35-2.42,17.16,1.3,2.12,1.16,3.86,2.98,5.7,4.91,4.34,4.55,9.75,10.21,23.42,10.27,7.79.04,12.06,1.11,14.28,3.6,2.51,2.82,2.04,7.04,1.38,12.88-.23,2.02-.48,4.31-.64,6.79-.93,14.76,7.79,25.42,7.87,25.52,5.21,6.2,11.62,19.06,8.85,26.98-1.16,3.32-3.76,5.41-7.72,6.21-1.58.32-3.02.47-4.34.47-9.56,0-13.06-7.93-17.69-18.41ZM89.1,470.35c-6.08-3.32-12.61-3.99-15.18-1.56-1.95,1.85-1.03,5.02.08,7.35,2.13,4.45,4.82,7.2,7.19,9.62,3.3,3.37,5.91,6.03,4.59,11.2-.26,1.01-.56,2.04-.86,3.06-2.1,7.18-4.08,13.96,6.91,18.9,2.58,1.16,4.94,2.09,7.03,2.91,8.69,3.41,14.44,5.67,20.59,18.66,1.15,2.42,2.15,4.7,3.13,6.91,5.31,12.04,8.52,19.31,20.14,16.96,3.33-.67,5.5-2.39,6.45-5.1,2.44-6.98-3.4-19.19-8.55-25.33-.38-.45-9.24-11.26-8.26-26.72.16-2.52.42-4.83.65-6.87.61-5.41,1.04-9.31-.96-11.57-1.83-2.06-5.85-2.99-13.01-3.03-14.39-.07-20.07-6.02-24.64-10.8-1.83-1.91-3.4-3.56-5.29-4.59h0Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "m",
    d: "M142.88,576.3l1.7-.09c-.08-1.59-2.22-39.16-17.31-50.16-16.55-12.06-21.77-25.03-24.25-33.73-2.93-10.25-17.83-12.99-18.46-13.1l-.3,1.67c.14.03,14.49,2.67,17.13,11.9,2.55,8.94,7.91,22.26,24.88,34.63,14.44,10.52,16.59,48.49,16.61,48.87Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "m",
    d: "M140.01,584.74c-3.55-1.77-3.42-8.87-3.23-19.63.25-13.59.58-32.21-6.53-49.33-7.56-18.19-.82-23.51,5.7-28.65,7.3-5.76,14.2-11.2.96-35.75-6.08-11.28-8.01-18.9-6.07-24,1.91-5.04,7.28-7,12.96-9.08,9.81-3.59,20.92-7.66,19.49-28.42-.44-6.36.31-10.28,2.35-12.32,2.22-2.21,5.5-1.97,9.29-1.7,5.73.42,12.22.89,17.88-6.49.59-1.84,6-18.3,12.46-21.12,1.36-.59,2.69-.58,3.96.02h0c4.47,2.14,7.06,4.67,7.92,7.74,1.51,5.35-2.41,11.38-6.95,18.37-7.13,10.98-15.21,23.42-6.83,38.23,11.08,19.58,5.23,26.43-2.87,35.91-4.64,5.43-9.9,11.59-13.42,21.63-2.83,8.08,2,15.78,6.66,23.23,5.85,9.34,11.9,19-.84,27.38-21.07,13.86-41.87,59.1-42.08,59.56l-.09.19-.16.13c-3.88,3.04-6.71,4.49-8.83,4.49-.64,0-1.22-.13-1.75-.39ZM191.98,519.36c11.35-7.47,6.25-15.62.33-25.06-4.65-7.43-9.92-15.84-6.83-24.69,3.62-10.34,8.99-16.63,13.73-22.17,7.94-9.29,13.18-15.43,2.69-33.97-8.89-15.7-.14-29.17,6.88-39.99,4.31-6.64,8.04-12.37,6.74-16.98-.73-2.58-3.02-4.76-7.02-6.67h0c-.81-.39-1.65-.39-2.55,0-6,2.61-11.51,20.04-11.57,20.21l-.04.14-.09.12c-6.23,8.24-13.56,7.7-19.45,7.27-3.52-.26-6.3-.46-7.97,1.21-1.65,1.64-2.26,5.24-1.86,10.99,1.52,22.03-10.74,26.52-20.6,30.13-5.54,2.03-10.32,3.78-11.96,8.09-1.75,4.6.15,11.78,5.98,22.59,13.91,25.81,6.13,31.95-1.41,37.89-6.3,4.97-12.25,9.66-5.19,26.66,7.25,17.45,6.91,36.27,6.66,50.02-.17,9.38-.3,16.79,2.28,18.08,1.51.75,4.41-.52,8.62-3.79,1.68-3.66,21.61-46.27,42.6-60.08Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M106.76,387.56c10.72-3.68,8.49,16.99,13.02,32.28,4.53,15.29,50.4,6.67,31.14,44.96-19.25,38.29,24.35,12.8,11.33,46.21-13.02,33.41-1.13,69.14-15.29,60.05-14.16-9.09-7.95-51.16-22.68-56.16-14.72-5-17.13-10.83-2.55-24.42,14.58-13.59-38.2-27.08-25.17-54.52,13.02-27.44-2.19-44.15,10.19-48.39Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M142.03,568.86c1.35-5.72,12.86-56.05,2.12-62.14-9.47-5.36-9.24-26.22-7.76-45.91,1.31-17.43-21.08-25.58-22.04-25.92l-.57,1.6c.22.08,22.12,8.06,20.91,24.19-1.52,20.23-1.68,41.69,8.62,47.52,8.16,4.62.65,45.07-2.94,60.27l1.65.39Z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "w",
    points: "182.48 550.94 167.17 609.01 132.96 609.01 117.65 550.94 182.48 550.94"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "b"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "j",
    points: "753.63 602.88 740.96 602.68 740.11 573.29 752.77 573.49 753.63 602.88"
  }), /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M740.53,594.31l13.83.22c.51,0,.94.38,1.03.89l1.84,11.3c.16,1.05-.56,2.04-1.61,2.2-.11.02-.22.02-.33.02-5-.16-12.18-.56-18.46-.67-7.33-.11-1.56.19-10.15,0-5.2-.09-6.33-5.37-4.12-5.8,10.02-2.02,10.54-4.26,14.88-7.27.91-.61,2-.92,3.1-.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M704.62,222.91c-1.09,4.3-2.35,8.2-3.66,12.26-1.31,4.06-2.77,7.98-4.3,11.95-3.1,8.05-6.81,15.85-11.1,23.34-.53.96-1.14,1.9-1.73,2.85l-.9,1.42-.44.72c-.14.22-.4.56-.59.84-1.61,2.29-3.52,4.34-5.7,6.1-3.93,3.12-8.39,5.5-13.17,7.03-4.33,1.43-8.81,2.37-13.35,2.8-2.21.25-4.42.34-6.61.37-2.24.03-4.48-.05-6.71-.26l-.25-9.52c7.37-1.47,14.51-3.91,21.24-7.24,2.87-1.46,5.5-3.36,7.78-5.63.89-.94,1.67-1.98,2.3-3.11l.25-.44.33-.62.65-1.24c.42-.82.87-1.56,1.26-2.51,3.34-7.03,6.29-14.24,8.82-21.6,1.34-3.72,2.57-7.49,3.83-11.25s2.4-7.66,3.5-11.25l18.52,5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M639.14,282.88l-14.38-1.56.68,14.44s10.89,2.65,15.44-5.66l-1.74-7.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M612.92,287.72l2.66,6.22c.44,1.03,1.45,1.7,2.57,1.73l7.3.17-.68-14.44-9.79,2.32c-1.6.39-2.57,2-2.19,3.59.03.14.08.28.13.41Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "i",
    points: "740.11 573.29 740.54 588.44 753.21 588.65 752.77 573.49 740.11 573.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M691.77,206.85c-6.8,8.54-12.99,24.9-15.56,34.24,7.55,12.56,22.33,10.36,22.33,10.36,0,0,12.23-9.68,16.23-21.26,4-11.58-10.99-38.45-23-23.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M770.33,208.65c3,21.88-1.56,50.34,1.9,91.82l-67.76,4.3c-12.33-52.61-13.65-74.7-14.96-89.22-.51-5.8,2.81-11.25,8.2-13.46,15.97-6.61,43.36-7.59,62.17-4.28,5.47.95,9.7,5.34,10.44,10.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M720.89,223.2c-6.05-.04-11.69,3.07-14.88,8.22h31.47c-4.06-5.04-10.12-8.05-16.59-8.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M738.43,232.6h-33.12c-.79,1.48-1.39,3.04-1.79,4.67h37.64c-.74-1.65-1.66-3.22-2.74-4.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M741.85,238.77h-38.67c-.24,1.39-.36,2.79-.34,4.2h40.24c-.29-1.43-.71-2.84-1.23-4.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M718.46,266.08h13.82c1.61-.67,3.1-1.57,4.44-2.69h-23.31c1.56,1.11,3.26,2.02,5.06,2.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M709.92,260.3h29.71c.71-.98,1.33-2.02,1.85-3.11h-34.07c.76,1.1,1.59,2.14,2.51,3.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M705.76,254.51h36.79c.36-1.12.62-2.27.78-3.44h-39.06c.41,1.18.91,2.33,1.49,3.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M743.39,244.91h-40.46c0,.13,0,.26,0,.39.12,1.16.33,2.31.61,3.44h39.98c.04-1.15,0-2.3-.12-3.44,0-.13,0-.26,0-.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M737.79,165.3l-18.3,16.15c2.63,6.86,3.69,14.25-6.74,17.52-.57.18-1.05.56-1.35,1.07-2.46,4.26-2.97,10.89,8.51,9.87,8.58-.73,16.59-4.61,22.49-10.89.88-.83.95-2.2.16-3.11-6.22-6.69-5.8-21.96-4.76-30.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M730.32,171.88l-10.89,9.57c.68,1.62,1.2,3.29,1.56,5.01,4.36-.82,9.99-5.49,10.07-9.62.09-1.69-.16-3.38-.73-4.96Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "m",
    d: "M703.49,142.69c-4.01,5.54-1.37,18.38,1.56,20.4,7.47-3.5,6.1-23.56-1.56-20.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M738.11,151.17c0,12.56.53,19.9-5.45,26.75-8.98,10.29-24.81,5.57-28.51-6.72-3.33-11.06-2.66-29.74,9.34-35.53,8.4-4.2,18.62-.8,22.82,7.6,1.23,2.45,1.84,5.16,1.8,7.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "m",
    d: "M737.27,163.6c1.84-4.2-8.09-1.7-8.09-1.7,0,0-1.56-13.45,2.71-18.67-4.31,2.57-15.73,2.49-18.1,0-4.81,2.43-11.19,3.11-15.27.33-4.08-2.79-3.87-9.41-1.24-12.57,3.35,3.11,8.09-1.18,5.98-3.28,6.69-4.01,18.04-1.84,20.23.47-1.07-1.71-.58-3.97,1.12-5.07,0,0,1.32,5.09,5.34,4.87,7.1-.39,15.41,2.04,12.23,8.75,5.07.53,7.5,6.32,5.99,10.89-1.51,4.58,3.03,5.4,3.55,4.01,1.71,3.22.34,5.14-2.63,6.32,7.78,8.99-8.81,11.73-11.89,17.59-.03-.06-2.15-6.8.08-11.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M744.74,163.03c-1.35,2.88-3.76,5.11-6.74,6.22-3.95,1.45-6.22-1.99-5.37-5.87.76-3.5,3.75-8.47,7.78-8.23s5.94,4.34,4.33,7.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "m",
    d: "M753.55,439.5c-4.08-63.8,3.84-138.17,3.84-138.17l-52.91,3.36c3.11,24.04,12.45,101.37,16.29,139.17,4.09,40.13,15.11,137.86,15.11,137.86l21.48.33s1.98-92.25-3.81-142.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M753.16,432.61c0-.84-.08-1.67-.12-2.51-1.31-28.73-.44-58.75.86-82.56l-3.27,2.07c-13.91,20.62-4.98,59.42,2.72,86.84-.06-1.28-.14-2.57-.19-3.84Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "m",
    points: "733.87 577.32 735.58 586.06 757.88 586.47 758.75 578.2 733.87 577.32"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "j",
    points: "823.64 603.8 810.94 603.62 805.02 574.2 817.7 574.41 823.64 603.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M821.79,594.59l-13.8-.12c-.38-.04-.73.23-.78.61,0,.08,0,.16.01.24l1.7,11.31c.27,1.27,1.35,2.2,2.65,2.29,4.95,0,6.43-.4,12.68-.34,7.31,0,4,.28,12.57.36,5.2,0,4.67-5.2,2.33-5.73-7.44-1.65-10.01-4.51-14.01-7.59-.98-.69-2.16-1.05-3.36-1.03Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "i",
    points: "805.02 574.22 808.07 589.36 820.76 589.56 817.71 574.41 805.02 574.22"
  }), /*#__PURE__*/React.createElement("path", {
    className: "m",
    d: "M797.87,438.57c-8.84-57.69-16.51-115.39-25.61-138.17l-44.85,2.83s25.23,98.85,38.11,138.86c6.22,42.02,37.18,140.7,37.18,140.7l20.14-.89s-16.06-85.64-24.96-143.33Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "m",
    points: "799.55 579.23 802.73 587.82 825.04 587.1 824.53 578.86 799.55 579.23"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M773.02,213.1c.72,1.14,1.24,2.02,1.84,3.02.59,1,1.07,1.93,1.56,2.91,1.03,1.95,2.01,3.91,2.97,5.87,1.88,3.98,3.56,8.05,5.03,12.2,1.51,4.19,2.76,8.46,3.73,12.81l.72,3.3.58,3.36c.2,1.1.31,2.26.44,3.39l.19,1.71.09.86v.86c.1,1.87-.22,3.73-.92,5.46-.38.95-.84,1.87-1.39,2.74-.82,1.3-1.77,2.51-2.83,3.63-1.71,1.78-3.56,3.43-5.52,4.93-3.53,2.67-7.22,5.11-11.06,7.31-7.36,4.25-15.03,7.95-22.94,11.05l-4.51-8.37c6.5-4.81,13.17-9.63,19.34-14.6,3.11-2.46,6.1-5.01,8.71-7.55,1.2-1.14,2.31-2.37,3.31-3.69.31-.43.59-.88.82-1.35.11-.22-.14-.3-.31,1.07v.82-.17l-.14-.67-.28-1.35c-.17-.9-.34-1.81-.59-2.71l-.68-2.69-.79-2.71c-1.1-3.59-2.37-7.17-3.81-10.72s-3.02-7.08-4.67-10.55c-.84-1.73-1.7-3.47-2.6-5.15l-1.37-2.52-1.29-2.33,16.39-10.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M745.6,288.33l-12.79,1.31,5.49,14.25s11.45-2.58,11.19-8.87l-3.89-6.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M724.12,299.89l2.79,4.67c1.12,1.86,3.43,2.62,5.43,1.77l5.96-2.44-5.49-14.32-6.96,4.16c-2.17,1.2-2.96,3.94-1.75,6.11,0,.02.02.03.03.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M737.49,219.92c3.72,10.1,16.95,23.34,23.61,30.22,14.78-.19,24.68-14.77,24.68-14.77,0,0-6.72-25.58-19.86-34.83-9.88-6.94-34.98,1.51-28.43,19.37Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "c"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "m",
    x: 403.35,
    y: 432,
    width: 306.94,
    height: 28.51
  }), /*#__PURE__*/React.createElement("rect", {
    className: "i",
    x: 623.16,
    y: 432,
    width: 87.13,
    height: 28.51
  }), /*#__PURE__*/React.createElement("rect", {
    className: "m",
    x: 403.35,
    y: 460.51,
    width: 18.38,
    height: 148.43
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "i",
    points: "421.71 468.49 403.35 464.51 403.35 460.51 421.71 460.51 421.71 468.49"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "m",
    x: 691.93,
    y: 460.51,
    width: 18.38,
    height: 148.43
  }), /*#__PURE__*/React.createElement("rect", {
    className: "i",
    x: 691.93,
    y: 460.51,
    width: 18.38,
    height: 148.43
  }), /*#__PURE__*/React.createElement("rect", {
    className: "m",
    x: 623.16,
    y: 460.51,
    width: 18.38,
    height: 148.43
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "i",
    points: "641.54 468.49 623.16 464.51 623.16 460.51 641.54 460.51 641.54 468.49"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "m",
    x: 460.86,
    y: 460.51,
    width: 18.38,
    height: 148.43
  }), /*#__PURE__*/React.createElement("rect", {
    className: "i",
    x: 460.86,
    y: 460.51,
    width: 18.38,
    height: 148.43
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "m",
    points: "679.1 288.83 448.99 288.83 428.56 378.31 658.67 378.31 679.1 288.83"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "f",
    points: "679.1 288.83 684.36 288.83 663.93 378.31 658.67 378.31 679.1 288.83"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "l",
    x: 361.81,
    y: 324.62,
    width: 369.02,
    height: 107.38,
    rx: 18.67,
    ry: 18.67
  }), /*#__PURE__*/React.createElement("rect", {
    className: "i",
    x: 651.09,
    y: 324.62,
    width: 79.76,
    height: 107.38,
    rx: 18.67,
    ry: 18.67
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M637.46,352.37h-262.02c-1.72,0-3.11-1.39-3.11-3.11h0c0-1.72,1.39-3.11,3.11-3.11h262.02c1.72,0,3.11,1.39,3.11,3.11h0c0,1.72-1.39,3.11-3.11,3.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M622.21,381.16h15.75c1.42,0,2.57-1.16,2.58-2.58h0c0-1.43-1.15-2.59-2.58-2.6h-15.75c-1.43,0-2.58,1.17-2.58,2.6h0c0,1.42,1.16,2.57,2.58,2.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M622.21,392.19h15.75c1.43,0,2.58-1.17,2.58-2.6h0c0-1.42-1.16-2.57-2.58-2.58h-15.75c-1.42,0-2.57,1.16-2.58,2.58h0c0,1.43,1.15,2.59,2.58,2.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M622.21,403.18h15.75c1.43,0,2.58-1.17,2.58-2.6h0c0-1.43-1.15-2.59-2.58-2.6h-15.75c-1.43,0-2.58,1.17-2.58,2.6h0c0,1.43,1.15,2.59,2.58,2.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "p",
    d: "M436.57,349.26c3.03-26.25-15.8-47.53-42.02-47.53h191.71c26.25,0,45.13,21.27,42.02,47.53h-191.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M436.57,349.26c3.03-26.25-15.8-47.53-42.02-47.53h191.71c26.25,0,45.13,21.27,42.02,47.53h-191.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "p",
    d: "M394.52,301.73h191.74c-26.24,0-49.97,21.27-53,47.53l-21.79,188.81c-3.02,26.25-26.75,47.53-53,47.53h-96.64c-26.25,0-45.13-21.27-42.02-47.53l21.79-188.81c2.99-26.25,26.67-47.53,52.93-47.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "v",
    d: "M394.52,301.73h191.74c-26.24,0-49.97,21.27-53,47.53l-21.79,188.81c-3.02,26.25-26.75,47.53-53,47.53h-96.64c-26.25,0-45.13-21.27-42.02-47.53l21.79-188.81c2.99-26.25,26.67-47.53,52.93-47.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "p",
    d: "M416.46,538.07c-3.03,26.25,15.8,47.53,42.02,47.53h-191.71c-26.25,0-45.13-21.27-42.02-47.53h191.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "w",
    d: "M416.46,538.07c-3.03,26.25,15.8,47.53,42.02,47.53h-191.71c-26.25,0-45.13-21.27-42.02-47.53h191.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M355.48,365.67h4.51l-1.68,14.57h-4.51l1.68-14.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M363.26,365.67h4.2l4.56,8.06.92-8.06h4.25l-1.68,14.57h-4.23l-4.54-8-.92,8h-4.23l1.68-14.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M378.68,365.67h4.67l2.07,10.49,4.44-10.49h4.58l-7.1,14.57h-4.87l-3.78-14.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M393.84,372.97c.15-2.12,1.09-4.1,2.63-5.56,1.6-1.37,3.66-2.08,5.76-1.99,2-.16,3.96.55,5.38,1.96,1.22,1.54,1.71,3.53,1.34,5.46-.13,1.48-.59,2.91-1.35,4.19-.68,1.08-1.64,1.96-2.77,2.55-2.58,1.16-5.52,1.2-8.14.12-1.03-.55-1.85-1.42-2.33-2.49-.56-1.34-.73-2.81-.51-4.25ZM398.33,372.97c-.22,1.06-.06,2.16.45,3.11.51.65,1.31,1.02,2.13.96.88.03,1.74-.31,2.35-.95.74-.98,1.15-2.17,1.18-3.39.22-1.03.05-2.1-.48-3-.52-.65-1.32-1-2.15-.95-.86,0-1.69.34-2.29.96-.74.93-1.16,2.08-1.2,3.27v-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M412.37,365.67h4.51l-1.68,14.57h-4.51l1.68-14.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M428.82,374.28l3.8,1.2c-.34,1.01-.87,1.95-1.56,2.77-.63.73-1.42,1.31-2.3,1.68-1.05.4-2.17.59-3.3.56-1.3.05-2.6-.18-3.8-.68-1.02-.53-1.83-1.39-2.32-2.43-.62-1.39-.83-2.94-.58-4.45.14-2.11,1.05-4.09,2.57-5.56,1.57-1.35,3.59-2.04,5.65-1.95,1.49-.1,2.96.29,4.2,1.12,1.04.87,1.73,2.09,1.95,3.42l-4.08.87c-.04-.34-.15-.67-.33-.96-.2-.33-.48-.61-.82-.79-.37-.19-.78-.29-1.2-.28-.98-.02-1.9.44-2.47,1.23-.57.85-.9,1.84-.95,2.86-.26,1.11-.13,2.28.36,3.31.45.62,1.19.96,1.96.9.75.04,1.48-.22,2.04-.72.55-.61.95-1.33,1.18-2.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M435.93,365.67h12.06l-.36,3.11h-7.56l-.26,2.32h7l-.34,2.97h-6.96l-.33,2.86h7.78l-.37,3.3h-12.28l1.62-14.57Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "y",
    points: "510.72 418.26 348.16 418.26 350.28 399.83 512.84 399.83 510.72 418.26"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "x",
    points: "510.72 418.26 348.16 418.26 346.44 433.29 509 433.29 510.72 418.26"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "l",
    points: "499.49 515.8 450.02 515.8 451.03 506.91 500.51 506.91 499.49 515.8"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "o",
    points: "499.49 515.8 450.02 515.8 449.18 523.07 498.65 523.07 499.49 515.8"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "x",
    points: "507.25 448.34 344.69 448.34 346.44 433.29 509 433.29 507.25 448.34"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "x",
    points: "507.25 448.34 344.69 448.34 342.96 463.39 505.53 463.39 507.25 448.34"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "x",
    points: "503.8 478.42 341.22 478.42 342.96 463.39 505.53 463.39 503.8 478.42"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "x",
    points: "503.8 478.42 341.22 478.42 339.49 493.47 502.05 493.47 503.8 478.42"
  }))), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "t",
    x1: 70.37,
    y1: 608.94,
    x2: 872.44,
    y2: 608.94
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "u",
    x: 49.97,
    y: 79.12,
    width: 280.38,
    height: 211.32,
    rx: 8.63,
    ry: 8.63
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "n",
    x: 34.31,
    y: 63.45,
    width: 280.38,
    height: 211.32,
    rx: 8.63,
    ry: 8.63
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "v",
    x: 8.33,
    y: 48.74,
    width: 289,
    height: 208.76,
    rx: 4.56,
    ry: 4.56
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "m",
    d: "M11.98,48.74h281.7c2.01,0,3.65,1.64,3.65,3.65v19.07H8.33v-19.07c0-2.01,1.64-3.65,3.65-3.65Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "r",
    cx: 255.33,
    cy: 59.75,
    r: 3.72
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "r",
    cx: 269.09,
    cy: 59.75,
    r: 3.72
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "r",
    cx: 282.85,
    cy: 59.75,
    r: 3.72
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "m",
    x: 31.76,
    y: 100.22,
    width: 91.27,
    height: 120.32
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M268.36,105.83c0,.45-28.65.82-63.97.82s-63.98-.37-63.98-.82,28.64-.82,63.98-.82,63.97.37,63.97.82Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M268.36,120.88c0,.45-28.65.82-63.97.82s-63.98-.37-63.98-.82,28.64-.82,63.98-.82,63.97.37,63.97.82Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M268.36,135.94c0,.45-28.65.82-63.97.82s-63.98-.37-63.98-.82,28.64-.82,63.98-.82,63.97.37,63.97.82Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M268.36,150.99c0,.45-28.65.82-63.97.82s-63.98-.37-63.98-.82,28.64-.82,63.98-.82,63.97.37,63.97.82Z"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    className: "w",
    x: 212.97,
    y: 163.47,
    width: 51.43,
    height: 57.07
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M204.53,166.05c0,.45-13.99.82-31.25.82s-31.25-.36-31.25-.82,13.99-.82,31.25-.82,31.25.37,31.25.82Z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M204.53,181.11c0,.45-13.99.82-31.25.82s-31.25-.37-31.25-.82,13.99-.82,31.25-.82,31.25.37,31.25.82Z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M204.53,198.56c0,.45-13.99.82-31.25.82s-31.25-.37-31.25-.82,13.99-.82,31.25-.82,31.25.36,31.25.82Z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M202.92,216.36c0,.45-13.99.82-31.25.82s-31.25-.36-31.25-.82,13.99-.82,31.25-.82,31.25.37,31.25.82Z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "v",
    d: "M405.02,31.23h153.72c4.48,0,8.12,3.64,8.12,8.12v153.72c0,4.48-3.64,8.12-8.12,8.12h-153.72c-4.48,0-8.12-3.64-8.12-8.12V39.35c0-4.48,3.64-8.12,8.12-8.12Z"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    className: "g",
    x: 442.53,
    y: 162.5,
    width: 78.69,
    height: 3.89
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    className: "g",
    x: 453.68,
    y: 174.74,
    width: 56.4,
    height: 3.89
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    className: "r",
    x: 424.6,
    y: 37.58,
    width: 114.56,
    height: 98.29
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    className: "m",
    x: 475.26,
    y: 143.51,
    width: 13.23,
    height: 2.45
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M521.52,48.88v2.4h14.11v13.24h2.4v-15.63h-16.5ZM425.73,64.52h2.4v-13.24h14.11v-2.4h-16.5v15.63ZM535.63,132.83v13.24h-14.11v2.4h16.5v-15.64h-2.4ZM428.13,132.83h-2.4v15.64h16.5v-2.4h-14.11v-13.24Z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M466.14,49.79s-.03,0-.05,0c-.46-.11-1.2-2.33-1.34-2.77-.03-.12-.11-.34-.21-.65-.57-1.78-1.92-5.93-1.4-7.53.17-.5.42-.79.77-.87.74-.15,1.58.78,1.61.82l.02.02v.03c.19,1.75,1.13,10.5.73,10.9-.04.04-.09.06-.14.06ZM464.09,38.12s-.09,0-.14.01c-.28.06-.49.31-.64.75-.51,1.54.88,5.81,1.4,7.42.1.31.17.54.21.66.34,1.06.94,2.59,1.22,2.66,0,0,.01,0,.02,0,.26-.35-.33-6.75-.77-10.73-.11-.12-.74-.76-1.3-.76Z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "s",
    d: "M481.38,14.92s11.29-1.18,15.36,9.72c4.07,10.9,7.9,14.47,8.38,20.2,1.94,23.16,12.76,17.92,9.71,31.28-3.04,13.35-5.15,15.37-5.15,15.37l-25.86-5.07-26.2.08s10.25-5.12,7.97-16.02c-2.28-10.9-7.97-28.77-4.76-40.94,3.21-12.17,13.8-13.69,20.55-14.62Z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M495.17,49.79c-.05,0-.1-.02-.14-.06-.4-.4.53-9.15.72-10.9v-.03s.02-.02.02-.02c.04-.04.88-.98,1.61-.82.34.07.6.36.77.87.52,1.59-.82,5.75-1.4,7.53-.1.31-.17.53-.2.65-.14.45-.88,2.67-1.34,2.78-.02,0-.03,0-.05,0ZM495.92,38.88c-.43,3.98-1.02,10.38-.77,10.73.01.01.02,0,.02,0,.27-.07.88-1.6,1.22-2.66.03-.12.11-.34.21-.65.52-1.61,1.9-5.88,1.4-7.42-.15-.44-.36-.69-.64-.75-.59-.12-1.31.62-1.44.75Z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M534.46,119.07h-16.11c-3.34-6.09-6.06-10.85-6.06-10.85,0,0-2.17,3.96-3.86,10.85h-54.25c-.83-4.3-.88-8.42-.71-11.35,0,0-2.9,5.24-6.26,11.35h-18.22c4.84-9.06,13.9-25.55,15.96-27.7,2.59-2.71,17.58-13.07,28.28-16.45,10.71-3.38,16.79-.12,16.79-.12,0,0,10.99,1.98,21.16,6.01,4,1.58,15.03,21.97,23.28,38.25Z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "q",
    d: "M482.87,21.3s14.95,2.16,12.76,24.23c-2.19,22.07-15.38,20.32-16.26,20.3-.88-.02-13.24.46-14.31-26.47,0,0-.5-19.91,17.81-18.06Z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "q",
    d: "M489.52,61.91s-.93,11.48,1.29,14.92c2.21,3.44-1.89,8.11-10.34,6.51-8.45-1.6-7.96-6.39-7.96-6.39,0,0,2.37-7.08,1.67-12.76-.69-5.67,15.34-2.29,15.34-2.29Z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "s",
    d: "M481.16,29.3s6.99,7.34,10.23,11.06c3.24,3.72,3.62,10.9,3.62,10.9,0,0,5.47-6.68,3.18-14.45-2.29-7.77-7.69-22.9-21.38-18.25-13.69,4.65-14.2,25.1-12.59,35.24,0,0,6.15-22.39,16.95-24.5Z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "q",
    d: "M494.76,75.82s-10.37,26.26-16.67,30.82c0,0-8.28-26.78-7.7-30.7,0,0,12.49-4.89,24.37-.12Z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "s",
    d: "M472.85,69.47s-18.48,16.44-13.69,26.7c4.09,8.76,18.61,3.39,16.22-5.79-2.39-9.17-2.53-20.92-2.53-20.92Z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M475.27,64.83s6.37,3.01,12.57-1.44c0,0-1.72,3.56-6.28,4.06-4.56.51-6.28-2.63-6.28-2.63Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWelcomeOnboarding);
export default __webpack_public_path__ + "static/media/welcome_onboarding.b77a6137ef84d9e6645fc6ef0910fb26.svg";
export { ForwardRef as ReactComponent };